import { ButtonSize, ButtonVariant } from "./Button.types";

export const BUTTON_VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary:
    "border border-[#7C66F0] bg-[#7C66F0] text-white hover:border-[#5D4DB4] hover:bg-[#5D4DB4] disabled:border-[#7C66F0] disabled:bg-[#9D8CF4]",
  secondary: "bg-[#f4f2ff] text-[#7c66f0]",
  outline:
    "border-[#C8D2DE] bg-white text-[#253747] hover:border-[#3F5266] hover:bg-[#4C637B0D] border disabled:text-[#5C6975]",
  ghost: "",

  danger:
    "border border-[#E64A47] bg-[#E64A47] text-white hover:border-[#C83F3C] hover:bg-[#C83F3C] disabled:border-[#E64A47] disabled:bg-[#F07A78]",
  "danger-secondary": "text-[#E64A47] bg-[#FCEEEC]",

  success:
    "border border-[#10B981] bg-[#10B981] text-white hover:border-[#0C8B61] hover:bg-[#0C8B61] disabled:border-[#10B981] disabled:bg-[#4CCBA1]",
  "success-secondary": "text-[#5abf91] bg-[#effbf4]",
} as const;

export const BUTTON_SIZE_CLASSES: Record<ButtonSize, string> = {
  xs: "h-6",
  sm: "h-8",
  md: "h-10",
  lg: "h-12",
} as const;

export const BUTTON_ICON_ONLY_SIZE_CLASSES: Record<ButtonSize, string> = {
  xs: "h-6 w-6",
  sm: "h-8 w-8",
  md: "h-9 w-9",
  lg: "h-10 w-10",
} as const;
